import React, { FC, ReactElement, useContext, useRef, useState } from 'react';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import { NavigationContext } from '@buyside/components/presentation/MainSiteLayout/mainSiteLayout';

import styles from './stickyHeaderStyles.scss';

const StickyHeader: FC<{
  children?: ({ isSticky }: { isSticky: boolean }) => ReactElement;
}> = ({ children }) => {
  const { sideNavigationOpen } = useContext(NavigationContext) || {};

  const [isSticky, setIsSticky] = useState(false);
  const [fillerHeight, setFillerHeight] = useState(0);
  const [marginBottom, setMarginBottom] = useState('0px');
  const [marginTop, setMarginTop] = useState('0px');

  const stickyRef = useRef<HTMLDivElement>(null);

  const handleVisibility = (isVisible: boolean): void => {
    if (stickyRef.current) {
      let fillerHeight = 0;
      let marginBottom = '0px';
      let marginTop = '0px';

      if (window.scrollY < stickyRef.current.offsetTop + fillerHeight) {
        setIsSticky(false);
        setFillerHeight(fillerHeight);
        setMarginBottom(marginBottom);
        setMarginTop(marginTop);
      } else {
        fillerHeight = stickyRef.current.offsetHeight;
        const child = stickyRef.current.firstChild;

        if (child) {
          const styles = window.getComputedStyle(stickyRef.current.firstChild as HTMLElement);
          marginBottom = styles.marginBottom || '0px';
          marginTop = styles.marginTop || '0px';
        }

        setIsSticky(!isVisible);
        setFillerHeight(fillerHeight);
        setMarginBottom(marginBottom);
        setMarginTop(marginTop);
      }
    }
  };

  return (
    <>
      <VisibilitySensor onChange={handleVisibility}>
        <div style={{ height: 1 }} />
      </VisibilitySensor>
      {isSticky ? (
        <div
          className={styles.adjustedMargin}
          style={{ height: fillerHeight, marginBottom, marginTop }}
        />
      ) : null}
      <div
        ref={stickyRef}
        className={
          isSticky
            ? classNames(styles.stickyContainer, {
                [styles.sideNavigationOpen]: Boolean(sideNavigationOpen)
              })
            : styles.adjustedMargin
        }
      >
        {typeof children === 'function' ? children({ isSticky }) : children}
      </div>
    </>
  );
};

export default StickyHeader;
